import { FormDropdown } from "semantic-ui-react";

export const NewHardcodedDropdownFormComponent = (props: {
  props: NewHardcodedDropdownFormComponentProps;
  data: any;
  setData: any;
}) => {
  return (
    <FormDropdown
      fluid
      selection
      search
      label={props.props.label}
      required={props.props.required}
      options={props.props.options}
      value={props.data[props.props.key]}
      onChange={(event, data) => {
        const newValues = { ...props.data };
        newValues[props.props.key] = data.value;
        props.setData(newValues);
      }}
    />
  );
};

export type NewHardcodedDropdownFormComponentProps = {
  type: "hardcoded_dropdown";
  key: string;
  label: string;
  required: boolean;
  options: { key: number; value: any; text: string }[];
};
